import type { HeadersMap, ParamsMap } from '../types';

export function createShareableUrl(state: {
	tenant?: string;
	cypher?: string;
	headers?: HeadersMap;
	params?: ParamsMap;
}): string {
	const url = new URL(window.location.href);
	const setParam = (k: string, v?: string) => {
		if (v && v.length) {
			url.searchParams.set(k, v);
		} else {
			url.searchParams.delete(k);
		}
	};
	const { tenant, cypher, headers, params } = state;
	setParam('tenant', tenant);
	// Remove stale overrides from the link we originally opened.
	url.searchParams.delete('tenantMode');
	url.searchParams.delete('siteCloudId');
	setParam('cypher', cypher);
	try {
		const headersStr = headers && Object.keys(headers).length ? JSON.stringify(headers) : '';
		const paramsStr = params && Object.keys(params).length ? JSON.stringify(params) : '';
		setParam('headers', headersStr);
		setParam('params', paramsStr);
	} catch {}
	return url.toString();
}
